import { useState, useCallback, type FC } from 'react';
import classnames from 'classnames';
import { AdUnit } from './AdUnit.tsx';

import { type OnSlotRenderEnded } from '../types.ts';

import styles from '../styles/ads.scss';

type Props = {
    adId: string;
    elementId: string;
    width?: number;
    height?: number;
};

export const SkyscraperAd: FC<Props> = ({ adId, elementId, width = 320, height = 82 }) => {
    const [hasAd, setHasAd] = useState(true);

    const onSlotRenderEnded: OnSlotRenderEnded = useCallback(
        (event, ref, elId) => {
            if (event.slot.getSlotElementId() === elId) {
                const iframe = ref.querySelector('iframe');

                if (!iframe && hasAd) {
                    document
                        ?.querySelector(`#${elId} div`)
                        ?.setAttribute('style', 'height: 0; width: 0;');
                    setHasAd(false);
                }
            }
        },
        [hasAd]
    );

    const skyScraperClasses = classnames(styles.skyScraper, { [styles.hasAd]: hasAd });

    return (
        <div className={skyScraperClasses} data-tn="skyscraper-ad">
            <AdUnit
                adId={adId}
                elementId={elementId}
                width={width}
                height={height}
                onSlotRenderEnded={(event, ref) => onSlotRenderEnded(event, ref, elementId)}
            />
        </div>
    );
};
